var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-mic-1045070 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1549 7.78294C14.8649 7.78294 14.6299 8.01569 14.6299 8.30294V11.0069C14.6299 13.2625 12.7773 15.0975 10.5001 15.0975C8.22281 15.0975 6.37019 13.2625 6.37019 11.0069V8.30294C6.37019 8.01569 6.1352 7.78294 5.84519 7.78294C5.55518 7.78294 5.32019 8.01569 5.32019 8.30294V11.0069C5.32019 13.6604 7.36454 15.8498 9.97505 16.1113V18.8065H8.64491C8.3549 18.8065 8.11991 19.0393 8.11991 19.3265C8.11991 19.6138 8.3549 19.8465 8.64491 19.8465H12.3552C12.6452 19.8465 12.8802 19.6138 12.8802 19.3265C12.8802 19.0393 12.6452 18.8065 12.3552 18.8065H11.0251V16.1113C13.6356 15.8498 15.6799 13.6604 15.6799 11.0069V8.30294C15.6799 8.01569 15.4449 7.78294 15.1549 7.78294ZM10.5001 14.508C12.4396 14.508 14.0176 12.9451 14.0176 11.024V4.43747C14.0176 2.51638 12.4396 0.953468 10.5001 0.953468C8.56049 0.953468 6.98255 2.51638 6.98255 4.43747V11.024C6.98255 12.9451 8.56049 14.508 10.5001 14.508ZM8.03255 4.43747C8.03255 3.08984 9.13946 1.99347 10.5001 1.99347C11.8606 1.99347 12.9676 3.08984 12.9676 4.43747V11.024C12.9676 12.3716 11.8606 13.468 10.5001 13.468C9.13946 13.468 8.03255 12.3716 8.03255 11.024V4.43747Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMic);
export default __webpack_public_path__ + "static/media/white_mic.466b680dc67ff34980efec721e6921ae.svg";
export { ForwardRef as ReactComponent };